import { ICreateUpdateMetrics, IMultiSelectInterface } from "../interfaces/Index";

export const normalizeMetricsCreateUpdatPayload = (req: ICreateUpdateMetrics): ICreateUpdateMetrics => {
    const payload: ICreateUpdateMetrics = {
        cityId: req.cityId,
        categoryMetrics: normalizeMultiSelectResponse(req.categoryMetrics),
        coreMetrics: normalizeMultiSelectResponse(req.coreMetrics)
    }
    return payload
}

const normalizeMultiSelectResponse = (
    metrics: Array<any>
  ) => {
    return metrics.map((val) => (val.id));
  };


export const normalizeFetchMetricsDetails = (req: ICreateUpdateMetrics): any => {
    const payload: ICreateUpdateMetrics = {
        categoryMetrics: req.categoryMetrics,
        cityId: req.cityId,
        coreMetrics: req.coreMetrics
    }
    return payload
}

export const normalizeCoreMetrics = (req: any) => {
    return req && req.map((coreMetrics: any) => {
        return (
            {id: coreMetrics, name: coreMetrics}
        )
    })
}

export const normalizeCategoriesForMetrics = (req: any) => {
    return req.map((categories: any) => {
        return ({
            id: categories.id,
            name: categories.value ? categories.value : categories.id
        })
    })
}